/* jshint -W003 */

(function ($) {

  function updateMoreHelp(moreHelp) {
    var gdhelp = JSON.parse(ux.utils.cookie.get('gdhelp') || null);
    if (gdhelp) {
      if (typeof gdhelp.more === 'number' && gdhelp.more === 1) {
        showMoreHelp(moreHelp);
      } else {
        hideMoreHelp(moreHelp);
      }
    }
  }

  function ready() {
    var moreHelp = $('#more-help');
    if (moreHelp.length) {
      updateMoreHelp(moreHelp);
    }
  }

  function productOnClick(evt) {
    var product = $(evt.currentTarget);
    if (product.length && product.attr('data-href')) {
      setTimeout(function () {
        window.location.href = product.attr('data-href');
      }, 100);
    }
  }

  function showMoreHelp(moreHelp) {
    moreHelp.addClass('active');
    moreHelp.find('.headline-primary').hide();
    $('#more-help-product').fadeIn(300, function () {
      moreHelp.find('.arrow-down').removeClass('arrow-down').addClass('arrow-up');
      if (ux.traffic && ux.traffic.impression) {
        ux.traffic.impression('mcx.help.home.product.more.impression');
      }
    });
  }

  function hideMoreHelp(moreHelp) {
    moreHelp.removeClass('active');
    $('#more-help-product').fadeOut(300, function () {
      moreHelp.find('.arrow-up').removeClass('arrow-up').addClass('arrow-down');
      moreHelp.find('.headline-primary').show();
    });
  }

  function setShowMoreProducts(val) {
    var gdhelp = JSON.parse(ux.utils.cookie.get('gdhelp') || null);
    if (!gdhelp) {
      gdhelp = {};
    }
    gdhelp.more = val;
    ux.utils.cookie.set('gdhelp', JSON.stringify(gdhelp), null, '');
  }

  function moreHelpOnClick() {
    var moreHelp = $(this);
    if (moreHelp.hasClass('active')) {
      setShowMoreProducts(0);
      hideMoreHelp(moreHelp);
    } else {
      setShowMoreProducts(1);
      showMoreHelp(moreHelp);
    }
  }

  $('#more-help').on('click', moreHelpOnClick);
  $('.top-help-product').on('click', productOnClick);
  $('#more-help-product-desktop a').on('click', productOnClick);
  $(document).ready(ready);

}(jQuery));

/* jshint +W003 */
